import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isMobileApp } from '../../utils/platform';


export default function MobileRedirect() {
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        const checkMobileRedirects = () => {
            if (!isMobileApp()) return;

            const alreadyLanded = sessionStorage.getItem('alreadyLanded');

            const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');
            const userInfo = localStorage.getItem('userInfo');
            const isAuthenticated = !!userInfo;
            const hasPin = localStorage.getItem('hasPin'); // Assuming this flag exists

            // 1. Onboarding Check
            if (!hasSeenOnboarding && location.pathname !== '/mobile/onboarding') {
                navigate('/mobile/onboarding');
                return;
            }

            //user should be taken to dashboard if authenticated and hasseen oboarding page true ins
            // Redirect to dashboard ONLY ON FIRST APP LOAD
            if (isAuthenticated && hasSeenOnboarding && !alreadyLanded) {
                sessionStorage.setItem('alreadyLanded', 'true');
                if (location.pathname === '/' || location.pathname.startsWith('/mobile')) {
                    navigate('/dashboard');
                }
                return;
            }

            // 2. PIN Login Check (if authenticated)
            // If user is logged in but hasn't entered PIN for this session
            // For now, we'll just check if they are on a protected route and redirect to PIN login if needed
            // But simpler: if app launches and user is logged in, show PIN screen
            // We can use a session flag 'isPinVerified'

            //const isPinVerified = sessionStorage.getItem('isPinVerified');

            // if (isAuthenticated && hasPin && !isPinVerified && location.pathname !== '/mobile/pin-login') {
            //     navigate('/mobile/pin-login');
            //     return;
            // }
        };

        checkMobileRedirects();
    }, [navigate, location]);

    return null;
}
